import { Icon } from '@components/primitives/Icon'
import Modal from '@components/primitives/Modal/index.client'
import { Text } from '@components/primitives/Text'
import { classMerge } from '@components/utilities/classMerge'
import { faClose } from '@fortawesome/pro-regular-svg-icons/faClose'
import ShareTrialButtonsGrid, {
  type ShareTrialButtonsGridProps,
} from './ShareTrialButtonsGrid'

export default function ShareTrialModal({
  className,
  onClose,
  shareTrialCodes,
  source,
  trialSlug,
  trialTitle,
  visible,
}: {
  className?: string
  onClose: () => void
  visible: boolean
} & ShareTrialButtonsGridProps) {
  return (
    <Modal
      bodyClassName='pb-4'
      className={classMerge(
        'my-[2%] max-h-[95vh] w-[95%] md:w-[676px]',
        className,
      )}
      onClose={onClose}
      showHeader={false}
      size='Large'
      visible={visible}
      wrapperClassName={'md:flex md:items-center md:justify-center'}
    >
      <div className='mx-auto flex w-full flex-col justify-center gap-4 px-0 py-4 md:p-4'>
        <div className={'flex flex-row items-center justify-between'}>
          <Text
            className='text-neutral900'
            element='h5'
            styleName='h4'
            value='Share this study with friends'
          />
          <div className='w-5 pt-2 hover:cursor-pointer' onClick={onClose}>
            <Icon
              aria-label='Close'
              className={'w-5 text-neutral900'}
              icon={faClose}
            />
          </div>
        </div>
        <ShareTrialButtonsGrid
          shareTrialCodes={shareTrialCodes}
          source={source}
          trialSlug={trialSlug}
          trialTitle={trialTitle}
        />
      </div>
    </Modal>
  )
}
